export enum DateRepresentationEnum {
  COMPLETE = "complete",
  DATE = "date",
  TIME = "time"
}
